import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, message } from "antd";

const ExpanseHeadsDrawer = ({ open, setOpen, data, isEdit, onSubmit }) => {
    const [form] = Form.useForm();
    const [isLoading, setLoading] = useState(false);

    const defaultData = {
        name: "",
    };

    useEffect(() => {
        if (open) {
            if (isEdit && data) {
                form.setFieldsValue(data);
            } else {
                form.resetFields();
            }
        }
    }, [open, isEdit, data, form]);

    const onFinish = async (values) => {
        if (values.percentage < 1 || values.percentage > 100) {
            message.error("Percentage must be between 1 and 100.");
            return;
        }
        setLoading(true);
        try {
            if (isEdit) {
                await onSubmit({ ...data, ...values });
            } else {
                await onSubmit(values);
            }
            form.resetFields();
            setOpen(false);
        } catch (err) {
            console.error(err);
            message.error("Failed to submit the form. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Drawer
            title={isEdit ? "Edit Expanse Head" : "Add Expanse Head"}
            width={450}
            placement="right"
            onClose={() => setOpen(false)}
            open={open}
            destroyOnClose
        >
            <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                autoComplete="off"
                initialValues={defaultData}
            >
                <Form.Item
                    label="Expense Head Name"
                    name="name"
                    rules={[{ required: true, message: "Please enter the Expanse Head name." }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item>
                    <Button
                        type="primary"
                        block
                        htmlType="submit"
                        loading={isLoading}
                    >
                        {isEdit ? "Update Expense Head" : "Add Expense Head"}
                    </Button>
                </Form.Item>
            </Form>
        </Drawer>
    );
};

export default ExpanseHeadsDrawer;
